// General
var SM_ROOT = "/_api/wix-ecommerce-renderer-web/store-manager/";
export var PROVISION_STORES = "".concat(SM_ROOT, "provision-store");
export var GRAPHQL_ENDPOINT = "/_api/wix-ecommerce-graphql-web/api";
export var CATALOG_COMMANDS_URL = "".concat(SM_ROOT, "catalog/{commandName}");
export var STORE_SETTINGS_COMMANDS = "".concat(SM_ROOT, "store-settings/{commandName}");
export var GRAPHQL_NODE_ENDPOINT = "/_api/wixstores-graphql-server/graphql";
export var EXECUTE_BULK_COMMANDS = "".concat(SM_ROOT, "{commandName}");
// Tax
export var CREATE_TAX_GROUP_URL = "".concat(SM_ROOT, "createTaxGroup");
export var SET_TAX_CALCULATOR = "".concat(SM_ROOT, "changeTaxCalculator");
export var ENABLED_TAX_GROUPS = "".concat(SM_ROOT, "enableTaxGroups");
export var TAX_RULES_API_URL = "".concat(SM_ROOT, "tax-rules");
export var UPDATE_TAX_GROUP_URL = "".concat(SM_ROOT, "updateTaxGroup");
export var CREATE_TAX_RULE_URL = "".concat(SM_ROOT, "createTaxRules");
export var UPDATE_TAX_RULE_URL = "".concat(SM_ROOT, "updateTaxRules");
export var DELETE_TAX_GROUP_URL = "".concat(SM_ROOT, "deleteTaxGroup");
export var DELETE_TAX_RULE_URL = "".concat(SM_ROOT, "deleteTaxRules");
export var SUBMIT_NEW_TAX_RULE_ACCOUNT_REQUEST = "".concat(SM_ROOT, "submitNewTaxAccountRequest");
// Abandoned Cart
export var ABANDONED_CARTS_API_ENDPOINT = '_api/abandoned-carts/v1/abandonedCarts';
// Orders Manager
export var ORDERS_COMMANDS_URL = "".concat(SM_ROOT, "order/{commandName}");
export var ORDER_EMAIL_PREVIEW_URL = "".concat(SM_ROOT, "order-email-preview");
export var BULK_MARK_ORDERS_AS_PAID_COMMAND = 'BulkMarkOrderAsPaidByStoreManager';
export var ADD_FULFILLMENT_URL = "".concat(SM_ROOT, "orders/createFulfillment");
export var UPDATE_FULFILLMENT_URL = "".concat(SM_ROOT, "orders/updateFulfillment");
export var EXPORT_ORDERS_URL = 'https://ecom.wix.com/storemanager/orders-export';
export var CANCEL_ORDER = "".concat(SM_ROOT, "orders/{orderId}/cancel");
export var REFUND_ORDER = "".concat(SM_ROOT, "orders/{orderId}/refund");
export var PREVIEW_CANCEL_EMAIL = "".concat(SM_ROOT, "orders/{orderId}/preview-email/cancel");
export var PREVIEW_REFUND_EMAIL = "".concat(SM_ROOT, "orders/{orderId}/preview-email/refund");
export var CALCULATE_REFUND = "".concat(SM_ROOT, "orders/{orderId}/calculate-refund");
// Fulfillment Services
export var FULFILLMENTS_URL = '/_api/wix-ecommerce-fulfillment/v1/';
export var ADD_FULFILLMENT_SERVICE = "".concat(FULFILLMENTS_URL, "fulfillers/unified");
export var ASSIGN_FULFILLER_TO_PRODUCT = "".concat(FULFILLMENTS_URL, "fulfillers/setProductsAssociations/byIds");
export var BULK_ASSIGN_FULFILLERS_TO_PRODUCTS_BY_FILTER = "".concat(FULFILLMENTS_URL, "fulfillers/setProductsAssociations/byFilter");
export var BULK_UNSET_FULFILLERS_FROM_PRODUCTS_BY_FILTER = "".concat(FULFILLMENTS_URL, "fulfillers/unsetProductsAssociations/byFilter");
// Purchase Plans
export var SUBSCRIPTION_URL = '/_api/subscriptions-server/v1/subscriptions';
//# sourceMappingURL=topology.js.map